import { format, endOfMonth, subMonths } from "date-fns"

import { startOfToday, endOfToday, subDays, startOfYesterday, endOfYesterday, startOfWeek, subWeeks, endOfWeek, startOfMonth } from "date-fns"
import { ptBR } from "date-fns/locale"

export const getDateRange = (period: any) => {
    const today = new Date()

    switch (period) {
      case '24h':
        return {
          startDate: format(startOfToday(), 'yyyy-MM-dd'),
          endDate: format(endOfToday(), 'yyyy-MM-dd')
        }
      case 'yesterday':
        return {
          startDate: format(startOfYesterday(), 'yyyy-MM-dd'),
          endDate: format(endOfYesterday(), 'yyyy-MM-dd')
        }
      case '7d':
        return {
          startDate: format(subDays(today, 7), 'yyyy-MM-dd'),
          endDate: format(today, 'yyyy-MM-dd')
        }
      case '14d':
        return {
          startDate: format(subDays(today, 14), 'yyyy-MM-dd'),
          endDate: format(today, 'yyyy-MM-dd')
        }
      case '30d':
        return {
          startDate: format(subDays(today, 30), 'yyyy-MM-dd'),
          endDate: format(today, 'yyyy-MM-dd')
        }
      case 'thisWeek':
        return {
          startDate: format(startOfWeek(today, { locale: ptBR }), 'yyyy-MM-dd'),
          endDate: format(today, 'yyyy-MM-dd')
        }
      case 'lastWeek':
        return {
          startDate: format(startOfWeek(subWeeks(today, 1), { locale: ptBR }), 'yyyy-MM-dd'),
          endDate: format(endOfWeek(subWeeks(today, 1), { locale: ptBR }), 'yyyy-MM-dd')
        }
      case 'thisMonth':
        return {
          startDate: format(startOfMonth(today), 'yyyy-MM-dd'),
          endDate: format(today, 'yyyy-MM-dd')
        }
      case 'lastMonth':
        return {
          startDate: format(startOfMonth(subMonths(today, 1)), 'yyyy-MM-dd'),
          endDate: format(endOfMonth(subMonths(today, 1)), 'yyyy-MM-dd')
        }
      case 'maximum':
        return {
          startDate: format(subDays(today, 365), 'yyyy-MM-dd'),
          endDate: format(today, 'yyyy-MM-dd')
        }
      case 'custom':
        return null
      default:
        return {
          startDate: format(startOfToday(), 'yyyy-MM-dd'),
          endDate: format(endOfToday(), 'yyyy-MM-dd')
        }
    }
  }